module.exports = __webpack_public_path__ + "static/img/order-pc-1.0e3e8960.png";